import { routes } from "consts";
import React from "react";
import { ChangelogArticle, ChangelogBody, LinkTo } from "../components";

export const Article20240910_2 = (): JSX.Element | null => {
  return (
    <ChangelogArticle date="10 Wrzesień, 2024" header="Patch 1.1.1" labels={["bugfix"]}>
      <ChangelogBody title="1. Kalendarz polityki cen">
        Poprawiono niedziałający kalendarz i pola wyboru dat na ekranie{" "}
        <LinkTo to={routes.COURSES_EDIT_NESTED.PAYMENTS_POLICY("1")}>polityki cen kursu</LinkTo>.
      </ChangelogBody>
      <ChangelogBody title="2. Walidacja hasła przy edycji użytkownika">
        Dodano walidację poprawności wprowadzonego hasła przy edycji użytkownika. Hasło musi zawierać przynajmniej jedną
        wielką literę, jedną małą, jedną cyfrę i jeden znak specjalny.
      </ChangelogBody>
      <ChangelogBody title="3. Poprawka paginacji">Poprawiono problem z przerzucaniem stron w tabelach.</ChangelogBody>
    </ChangelogArticle>
  );
};
